import React, { useContext, useEffect } from "react";
import { Form } from "antd";

import { Researches } from "./researches";
import { FormContainer } from "../../../../../../shared";
import { fieldValidationMessages } from "../../../../../../../utils";
import {
  NewExpertContext
} from "../../../../../../../contexts/experts/new/context";

const { Item } = Form;

export const ResearchesForm = ({ editable = true }) => {
  const {
    onFormFieldsChange,
    form,
    data = {}
  } = useContext(NewExpertContext);

  const { user = {} } = data;
  const {
    papers = []
  } = user?.expertProfile?.professionalExperience || {};

  useEffect(() => {
    form.setFieldsValue({
      papers
    });
  }, [data]);

  return (
    <FormContainer>
      <Form
        validateMessages={fieldValidationMessages}
        onFieldsChange={onFormFieldsChange}
        layout="vertical"
        form={form}>
        <Item
          name="papers"
          trigger="onSave"
          valuePropName="papers"
          initialValue={papers}
          label={editable && "Investigaciones y publicaciones"}
          rules={[{ required: true }]}>
          <Researches editable={editable} />
        </Item>
      </Form>
    </FormContainer>
  );
};
